import React, { CSSProperties } from 'react'

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

type TabPanelProps = {
  children?: React.ReactNode;
  value: any;
  index: number;
  style?: CSSProperties;
}
const TabPanel: React.FC<TabPanelProps> = (props) => {
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={props.value !== props.index}
      id={`scrollable-auto-tabpanel-${props.index}`}
      aria-labelledby={`scrollable-auto-tab-${props.index}`}
    >
      <Box p={3} style={props.style}>{props.children}</Box>
    </Typography>)
}

export default TabPanel;